export default __webpack_public_path__ + "static/media/withdrawal-mlt.13cc1e56.svg";